import React, {useState, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';

import styled from '@emotion/styled';

import {formatPrice} from '../helpers/Helper.js';
import {getResourceFile} from '../network';
import OverlayComponent from './shared/OverlayComponent.js';


const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  width: 17rem;
  height: 30rem;
  
  padding: 1rem;
  
  background: white;
  
  border: 1px solid #EDEDED;
  box-sizing: border-box;
  /* shadow-base */
  z-index:1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.5rem;
  
  cursor: pointer;

  > span {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    
    min-width: 3.5rem;
    height: 1.25rem;
    z-index:1;
    
    font-size: 0.75rem;
    line-height: 0.75rem;
    font-weight: bold;
    color: white;
    
    padding: 0.25rem 0.5rem;
    background: var(--color-orange-500);
    box-shadow: 0 4px 6px rgba(221, 107, 32, 0.18), 0 2px 4px rgba(221, 107, 32, 0.12);
    border-radius: 2.5rem;
  }
`;


const ImageContainer = styled.div`
  display: flex;
  width: auto;
  height: 13.75rem;
  
  background: white;
  
  > img {
    position:relative;
    width: 90%;
    height: 90%;
    object-fit: contain;
    z-index:0;
    padding: 1rem;
  }
  
  
`;

const OptionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 1.875rem;
  
  background: #EDEDED;
  /* default/neutral-gray/400 */
  border: 1px solid #B8B8B8;
  box-sizing: border-box;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  line-height: 0.875rem;
  color: #5C5C5C;
  
  > span {
    
    font-size: 0.875rem;
    line-height: 0.875rem;
    
    color: #5C5C5C;
  }
  

`;
const AddCartButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 1.875rem;
  
  background: #EDEDED;
  /* default/neutral-gray/400 */
  border: 1px solid #B8B8B8;
  box-sizing: border-box;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  line-height: 0.875rem;
  transition:background-color 0.2s ease-in, color 0.2s ease-in;
  color: #5C5C5C;
  
  > span {
    
    font-size: 0.875rem;
    line-height: 0.875rem;
    
    color: #5C5C5C;
  }
  &:hover{
      background-color:var(--color-blue-500);
      color:var(--color-white);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.12);
  }

`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  padding-bottom:2.8rem;
  
  > span {
    font-size: 0.875rem;
    line-height: 1.25rem;
    
    color: #757575;
  }
`;

const Price = styled.div`
  display: flex;
  flex-direction: row;
  
  align-items: center;
  
  > .current {
    color: #232323;
    font-size: var(--font-20);
    line-height: var(--font-20);
    font-weight: 500;
    
    margin-right: var(--space-8);
  }
  
  > .strikethrough {
    color: var(--color-gray-500);
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: 500;
  }
`;

const Title = styled.div`
    font-style: normal;
    font-weight: normal;
    line-height: 1.375rem;
    font-size: var(--font-16);
    color: #232323;
    
    margin-top: 1rem;
`;

const Brand = styled.span`
    font-style: normal;
    font-weight: 600;
    line-height: 1.375rem;
    font-size: var(--font-16);
    color: #232323;
`;

const SmallCardContainer = styled.div`
  display:flex;
  flex-direction:row;
  max-width: 27rem;
  height: 10rem;
  min-width:20rem;
  padding: 1rem;
  
  background: white;
  
  border: 1px solid #EDEDED;
  box-sizing: border-box;
  /* shadow-base */

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.5rem;
  
  cursor: pointer;
  > span {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        min-width: 3.5rem;
        height: 1.25rem;
        z-index:1;
        
        
        font-size: 0.75rem;
        line-height: 0.75rem;
        font-weight: bold;
        color: white;
        
        padding: 0.25rem 0.5rem;
        background: var(--color-orange-500);
        box-shadow: 0 4px 6px rgba(221, 107, 32, 0.18), 0 2px 4px rgba(221, 107, 32, 0.12);
        border-radius: 2.5rem;
      }
`;

const SmallImageContainer = styled.div`
    display: flex;
    width: 9rem;
    height: 8.75rem;

    background: white;

    > img {
    position:relative;
    width: 60%;
    height: 60%;
    object-fit: contain;
    z-index:0;
    padding: 1rem;
    }

  
`;

const SmallTitle = styled.div`
    font-style: normal;
    font-weight: normal;
    line-height: 1.375rem;
    font-size: var(--font-16);
    color: #232323;
    
    margin-top: 1rem;
`;

const SmallBrand = styled.span`
    font-style: normal;
    font-weight: 600;
    line-height: 1.375rem;
    font-size: var(--font-16);
    color: #232323;
`;
const SmallContainer = styled.div`
      display:flex;
      flex-direction:column;
      height:2rem;
      justify-content:space-between;
`;
const SmallPriceContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: auto;

    > span {
    font-size: 0.875rem;
    line-height: 1.25rem;
    
    color: #757575;
    }
`;
const SmallPrice = styled.div`
    display: flex;
    flex-direction: column;

    > .current {
    color: #232323;
    font-size: var(--font-20);
    line-height: var(--font-20);
    font-weight: 500;
    
    margin-right: var(--space-8);
    }

    > .strikethrough {
    color: var(--color-gray-500);
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: 500;
    }
`;

const MobileCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  
  height: 7.5rem;
  min-width: 20rem;
  max-width: 27rem;
  
  padding: 0 var(--space-12);
  
  background: white;
  
  cursor: pointer;
  box-shadow: ${(props) =>
        (props.shadow ? '0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12)' : 'none')};
  border-radius: ${(props) =>
        (props.shadow ? '0.5rem' : 'none')};
  
  > span {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 2.625rem;
    height: var(--space-20);
    
    border-radius: var(--space-20);
    
    margin-top: var(--space-8);
    margin-left: var(--space-8);
    
    background: var(--color-orange-500);
    box-shadow: 0px 4px 6px rgba(221, 107, 32, 0.18), 0px 2px 4px rgba(221, 107, 32, 0.12);
    
    color: white;
    
    font-style: normal;
    font-weight: bold;
    font-size: var(--font-12);
    line-height: var(--font-12);
  }
`;

const MobileImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  
  width: 7.125rem;
  min-width: 7.125rem;
  height: 6rem;
  
  margin-right: var(--space-20);
  
  > img {
    object-fit: contain;
    width: inherit;
    height: inherit;
  }
`;

const MobileContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  height: 100%;
`;

const MobileTitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-16);
  line-height: 1.375rem;
  
  color: var(--color-gray-900);
  
  margin-top: var(--space-12);
  
  // ensure text for card doesn't pass 2 lines
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  
  > span {
    font-weight: 600;
  }
`;

const MobilePriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  
  margin-bottom: var(--space-12);
  
  //> span {
  //  font-size: 0.875rem;
  //  line-height: 1.25rem;
  //  
  //  color: #757575;
  //}
`;

const MobilePrice = styled.div`
    display: flex;
    flex-direction: column;

    > .current {
        color: var(--color-gray-900);
        font-style: normal;
        font-size: var(--font-18);
        line-height: var(--font-18);
        font-weight: 500;
    }

    > .strikethrough {
        color: var(--color-gray-600);
        font-style: normal;
        font-size: var(--font-14);
        line-height: var(--font-16);
        font-weight: 500;
    }
`;

/**
 * Receives product object and itemSmall boolean and renders a small or normal sized product item container
 * @author Paul V
 */
function ProductItem(props) {
    const {product, itemSmall, setDisplay, setItem, shadow} = props;
    const history = useHistory();

    useEffect(() => {
        console.log(history.location.pathname);
    });

    const previewImage = () => {
        let src = null;
        if (product.media && product.media.length) {
            for (let i = 0; i < product.media.length; i++) {
                if (product.media[i].type === 'image') {
                    src = getResourceFile(product.media[i].resource);
                    break;
                }
            }
        }

        if (!src) {
            if (product.variants && product.variants.length) {
                for (let i = 0; i < product.variants.length; i++) {
                    const variant = product.variants[i];
                    for (let i = 0; i < variant.media.length; i++) {
                        if (variant.media[i].type === 'image') {
                            src = getResourceFile(variant.media[i].resource);
                            break;
                        }
                    }
                }
            }
        }

        return src;
    };

    const checkIfSale = () => {
        let result = null;

        for (let i = 0; i < product?.variants.length; i++) {
            const variant = product?.variants[i];
            if (variant && variant?.discount > 0 && variant?.discount_expiration > 0) {
                result = variant;
                break;
            }
        }

        return result;
    };

    const displayedVariant = checkIfSale() || product?.variants[0];

    const renderNormal =
            // <Link to={`/products/${product._id}`}>
            <CardContainer>
                {checkIfSale() && <span>Sale</span>}
                <ImageContainer>
                    {previewImage() && <img src={previewImage()} alt={product.name}/>}
                </ImageContainer>
                {/* <OptionsContainer>
                <span>More Choices Available</span>
                </OptionsContainer> */}
                <Title>
                    <Brand>{product.brand.name}</Brand>{` ${product.name}`}{`${displayedVariant.description ? `, ${displayedVariant.description}` : ''}`.trim()}
                </Title>
                <PriceContainer>
                    {checkIfSale() ?
                        <>
                            <Price>
                                <span className="current">{formatPrice((displayedVariant.price) - (displayedVariant.price / 100) * displayedVariant.discount)}</span><span
                                className="strikethrough"><s>{formatPrice(displayedVariant.price)}</s></span>
                            </Price>
                        </> : <Price>
                            <span className="current">{formatPrice(displayedVariant.price)}</span>
                        </Price>
                    }
                    {product.prescription_required && <span>Prescription Required</span>}
                </PriceContainer>
                {/* {history.location.pathname === "/products" || history.location.pathname === "/products/" ? */}

                <AddCartButton onClick={() => {
                    setItem({
                        product: product,
                        image: previewImage(),
                        media: product.media
                    });
                    setDisplay(true);
                }}>
                    Add To Cart
                </AddCartButton>
            </CardContainer>
        // </Link>
    ;

    const renderSmall = <Link to={`/products/${product._id}`}>
        <MobileCardContainer shadow={shadow}>
            {checkIfSale() && <span>Sale</span>}
            <MobileImageContainer>{previewImage() && <img src={previewImage()} alt={product.name}/>}</MobileImageContainer>
            <MobileContentContainer>
                <MobileTitle>
                    <span>{product.brand.name}</span>{` ${product.name}`}{`${displayedVariant.description ? `, ${displayedVariant.description}` : ''}`.trim()}
                </MobileTitle>
                <MobilePriceContainer>
                    {
                        checkIfSale() ?
                            <MobilePrice>
                                <span className="strikethrough"><s>{formatPrice(displayedVariant.price)}</s></span>
                                <span className="current">
                                    {formatPrice((displayedVariant.price) - (displayedVariant.price / 100) * displayedVariant.discount)}
                                </span>
                            </MobilePrice> :
                            <MobilePrice>
                                <span className="current">{formatPrice(displayedVariant.price)}</span>
                            </MobilePrice>
                    }
                    {/*{product.prescription_required && <span>Prescription Required</span>}*/}
                </MobilePriceContainer>
            </MobileContentContainer>
        </MobileCardContainer>
    </Link>;

    // const renderSmall = <Link to={`/products/${product._id}`}>
    //     <SmallCardContainer>
    //         {checkIfSale() && <span>Sale</span>}
    //         <SmallImageContainer>
    //             {previewImage() && <img src={previewImage()} alt={product.name}/>}
    //         </SmallImageContainer>
    //         {/* <OptionsContainer>
    //         <span>More Choices Available</span>
    //         </OptionsContainer> */}
    //         <SmallContainer>
    //             <SmallTitle>
    //                 <SmallBrand>{product.brand.name}</SmallBrand>{` ${product.name}`}{`${displayedVariant.description ? `, ${displayedVariant.description}` : ''}`.trim()}
    //             </SmallTitle>
    //             <SmallPriceContainer>
    //                 {
    //                     checkIfSale() ?
    //                         <>
    //                             <SmallPrice>
    //                                 <span className="strikethrough"><s>{formatPrice(displayedVariant.price)}</s></span>
    //                                 <span
    //                                     className="current">{formatPrice((displayedVariant.price) - (displayedVariant.price / 100) * displayedVariant.discount)}</span>
    //
    //                             </SmallPrice>
    //                         </> : <SmallPrice>
    //                             <span className="current">{formatPrice(displayedVariant.price)}</span>
    //                         </SmallPrice>
    //                 }
    //                 {product.prescription_required && <span>Prescription Required</span>}
    //             </SmallPriceContainer>
    //         </SmallContainer>
    //     </SmallCardContainer>
    // </Link>;

    return itemSmall ? renderSmall : renderNormal;
}

ProductItem.propTypes = {
    product: PropTypes.object,
    itemSmall: PropTypes.bool
};


export default ProductItem;
